<template>
  <div class="login_page">
    <div class="welcome_login">
      <h1>欢迎登录</h1>
      <div class="login_text">请使用您本人的账号密码登录</div>
      <div class="login_form">
        <el-form
        :model="loginForm"
        status-icon
        :rules="rules"
        ref="loginForm"
        label-width="100px"
        class="demo-loginForm"
      >
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="loginForm.username"
            autocomplete="off"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            autocomplete="off"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="submitForm('loginForm')"
          ></el-input>
        </el-form-item>
        <div class="forgetPwd"><a href="">忘记密码？</a></div>
        <el-form-item>
          <el-button type="info" @click="submitForm('loginForm')">提交</el-button>
        </el-form-item>
      </el-form>
      </div>
      
      <div class="register">没有账号？去注册</div>
    </div>
    <div class="pic">
      <div class="pujie_pic"><img src="../../assets/login/logo.png" alt=""></div>        
      <div class="intor1">普杰配置管理平台</div>
      <div class="intor2">CONFIGURATION MANAGEMENT PLATFORM</div>
    </div>
  </div>
</template>
<script>
//引入登录接口
import { login } from "@/api"
//引入store
import {mapMutations} from "vuex"
export default {
  data() {
    //rule表单验证对象
    //value输入值
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();  
      }
    };
    var validatePwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        // username: [{ validator: validateUsername, trigger: "blur" }],
        username: [
          {required: true,message: '请输入用户名',trigger: 'blur'},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("只能输入2-30个中文、字母、数字、中划线、下划线"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
          // {pattern: /^(\w){2,11}$/, message: '只能输入2-11个字母、数字、下划线'}
        ],
        // password: [{ validator: validatePwd, trigger: "blur" }],
        password: [
          {required: true,message: '请输入密码',trigger: 'blur'}, 
          { min: 5,max: 25,message: '长度在 5 到 25个字符'}, 
          {pattern: /^(\w){5,25}$/, message: '只能输入5-25个字母、数字、下划线'}
        ],
      },
    };
  },
  methods: {
    //store中的用户信息
    ...mapMutations(['SET_USERINFO']),
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {//本地校验通过
          //正在登录动画效果
          const loading = this.$loading({
            lock: true,
            text: '登录中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          //   console.log(this.loginForm.username,this.loginForm.password);
          //发送登入请求
          let { username,password } = this.loginForm
          //发送登入请求
          login(username,password)
            .then(res=>{
              //结束登录动画
                loading.close();
                console.log(res.data.data.token,res,"登录成功后返回用户信息");
                if(res.data.code == "0"){
                  this.$message.success("登录成功")
                  //登录成功从后端获取的用户信息及token存储在本地
                  localStorage.setItem("userInfo",JSON.stringify(res.data.data.userInfo))
                  localStorage.setItem("token",JSON.stringify(res.data.data.token))
                  console.log(localStorage.getItem("userInfo"),localStorage.getItem("token"))
                  //修改store中的userinfo,将用户信息存到了vuex
                  this.SET_USERINFO(res.data.data.userInfo)
                  //登录成功跳转到主页
                  this.$router.push('/Home/homeIndex')
                }else{
                  this.$message.warning(res.data.message)
                }
            })
            .catch(err=>{
              console.log(err);
              this.$message.error(res.data.message)
            })
        //   this.$router.push('/home')
        } else {
          this.$message.error("登录校验不通过");
          // return false;
        }
      });
    },
    
  },
  created() {
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.$route.path=='/home'&&(e.code=='Enter'||e.code=='enter')){//验证在登录界面和按得键是回车键enter
        that.submitForm('loginForm');//登录函数
      }
    }
  }
};
</script>

<style scoped>
.login_page{
    width: 100%;
    height: 100%;
}
/* 登录区 */
.welcome_login{
    width: 45%;
    height: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.welcome_login h1{
    height: 15%;
    width: 50%;
    display: flex;
    align-items: flex-end;
    font-size: 60px;
}
.welcome_login .login_text{
    height: 15%;
    width: 50%;
    font-size: 20px;
    color:#9289A6;
    font-size: 32px;
    display: flex;
}
.login_form{
  height: 30%;
  width: 50%;
}
.login_form >>> .el-form-item__content{
  margin-left: 0px!important;
}
.login_form >>> .el-input{
    width: 80%;
    height: 100%;
}
.login_form >>> .el-input__inner{
  height: 50px!important;
   border: 1px solid #000; 
}
.login_form >>> .el-button{
    width: 80%;
    margin-top: 40px;
    font-size: 23px;
    background: #333;
}
.register{
    width: 25%;
    color: #8D9EAD;
}
.forgetPwd a{
  text-decoration: none;
  color: #333;
}
/* 图片区 */
.pic{
    width: 55%;
    height: 100%;
    float: right;
    background: url(../../assets/login/background.png);
    background-size: 100% 100%;
    position: relative;
}
.pic img{
    position: absolute;
    top: 50px;
    right: 60px;
    width: 250px;
    height: 100px;
}
.pic .intor1{
    position: absolute;
    top: 300px;
    right: 60px;
    font-size: 70px;
    font-weight: bold;
    color: white;
}
.pic .intor2{
    position: absolute;
    top: 420px;
    right: 60px;
    font-size: 25px;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login/index.vue